import { useState, useEffect } from 'react';
import axios from 'axios';

const useGeneratedDocuments = () => {
  const [documentosGerados, setDocumentosGerados] = useState([]);
  const [loadingDocumentos, setLoadingDocumentos] = useState(false);
  const [dialogVerTexto, setDialogVerTexto] = useState({ isOpen: false, conteudo: '', nomeArquivo: '' });
  const [dialogAlterar, setDialogAlterar] = useState({
    isOpen: false,
    documentoId: null,
    textoOriginal: '',
    instrucoes: '',
    nomeArquivo: ''
  });
  const [menuAberto, setMenuAberto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    carregarDocumentosGerados();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const carregarDocumentosGerados = async () => {
    setLoadingDocumentos(true);
    try {
      const response = await axios.get('/api/documentos/gerados');
      if (response.data.success) {
        setDocumentosGerados(response.data.data);
      }
    } catch (err) {
      console.error('Erro ao carregar documentos:', err);
    } finally {
      setLoadingDocumentos(false);
    }
  };

  const abrirDialogVerTexto = (documento) => {
    setDialogVerTexto({
      isOpen: true,
      conteudo: documento.texto_integral,
      nomeArquivo: documento.file_name
    });
    setMenuAberto(null);
  };

  const fecharDialogVerTexto = () => {
    setDialogVerTexto({ isOpen: false, conteudo: '', nomeArquivo: '' });
  };

  const copiarTextoDialog = () => {
    navigator.clipboard.writeText(dialogVerTexto.conteudo).then(() => {
      alert('Texto copiado para área de transferência!');
    }).catch(err => {
      console.error('Erro ao copiar:', err);
    });
  };

  const abrirDialogAlterar = (documento) => {
    setDialogAlterar({
      isOpen: true,
      documentoId: documento.id,
      textoOriginal: documento.texto_integral,
      instrucoes: '',
      nomeArquivo: documento.file_name
    });
    setMenuAberto(null);
  };

  const fecharDialogAlterar = () => {
    setDialogAlterar({ isOpen: false, documentoId: null, textoOriginal: '', instrucoes: '', nomeArquivo: '' });
  };

  const submeterAlteracao = async () => {
    if (!dialogAlterar.instrucoes.trim()) {
      setError('Por favor, forneça instruções de alteração');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const response = await axios.post('/api/documentos/alterar', {
        documento_id: dialogAlterar.documentoId,
        instrucoes_alteracao: dialogAlterar.instrucoes
      });
      if (response.data.success) {
        alert('Documento alterado com sucesso!');
        fecharDialogAlterar();
        carregarDocumentosGerados();
      }
    } catch (err) {
      console.error('Erro ao alterar documento:', err);
      setError('Erro ao alterar documento');
    } finally {
      setLoading(false);
    }
  };

  const downloadDocx = async (documento) => {
    setLoading(true);
    try {
      const nomeBase = documento.file_name.replace('.txt', '');
      const response = await axios.post(
        '/api/documentos/gerar-docx',
        { texto_integral: documento.texto_integral, nome_arquivo_base: nomeBase },
        { responseType: 'blob' }
      );
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${nomeBase}.docx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Erro ao baixar DOCX:', err);
      setError('Erro ao gerar arquivo DOCX');
    } finally {
      setLoading(false);
      setMenuAberto(null);
    }
  };

  const formatarData = (isoString) => {
    const data = new Date(isoString);
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = String(data.getFullYear()).slice(-2);
    const hora = String(data.getHours()).padStart(2, '0');
    const min = String(data.getMinutes()).padStart(2, '0');
    return `${dia}/${mes}/${ano} - ${hora}:${min}`;
  };

  return {
    documentosGerados,
    loadingDocumentos,
    dialogVerTexto,
    setDialogVerTexto,
    fecharDialogVerTexto,
    dialogAlterar,
    setDialogAlterar,
    fecharDialogAlterar,
    menuAberto,
    setMenuAberto,
    loading,
    error,
    carregarDocumentosGerados,
    abrirDialogVerTexto,
    copiarTextoDialog,
    abrirDialogAlterar,
    submeterAlteracao,
    downloadDocx,
    formatarData
  };
};

export default useGeneratedDocuments;
